import store from "../store";
import axios from "axios";
import { authActions } from "../reducers/auth";
import API_BASE_URL from "../../config/baseUrl";

const { dispatch } = store;

const LOGIN_API_URL = `${API_BASE_URL}/login/cleint-login`;

export const login = async function (userId, password) {
  dispatch(authActions.requestStart());

  try {
    const normalizedUserId = (userId || "").toLowerCase();
    const hostname = window?.location?.hostname || "urb99.com";
    const hostParts = hostname.split(".");
    // const baseDomain = 'urb99.com';
    const baseDomain = hostParts.length >= 2 ? hostParts.slice(1).join(".") : hostname;
    const subdomain = normalizedUserId.includes("aa")
      ? "superadmin"
      : "admin";
    const loginDomain = `${subdomain}.${baseDomain}`;

    const response = await axios.post(LOGIN_API_URL, {
      userId: userId,
      password: password,
      url: loginDomain,
    });

    const data = response.data;

    // Check if API returned status: false
    if (data.status === false) {
      const errorMessage = data.message || "Login failed";
      dispatch(authActions.requestFail(errorMessage));
      return { success: false, error: errorMessage };
    }

    // Check if token exists in response
    if (!data.token) {
      const errorMessage = "Invalid response from server";
      dispatch(authActions.requestFail(errorMessage));
      return { success: false, error: errorMessage };
    }

    const accessToken = data.token;
    const user = {
      userId: data.userId,
      username: data.username,
      userTypeInfo: data.userTypeInfo,
      ps: data.ps,
    };

    dispatch(authActions.loadUser({ user: user, accessToken: accessToken }));

    return { success: true };
  } catch (err) {
    let errorMessage = "Login failed. Please try again.";

    if (err.response) {
      const responseData = err.response.data;

      if (responseData && responseData.message) {
        errorMessage = responseData.message;
      } else if (err.response.status === 401) {
        errorMessage = "Invalid UserId or Password";
      } else if (err.response.status === 404) {
        errorMessage = "Service not found";
      } else if (err.response.status === 500) {
        errorMessage = "Server error. Please try again later.";
      }
    } else if (err.request) {
      errorMessage =
        "Unable to connect to server. Please check your internet connection.";
    } else {
      errorMessage = err.message || "An unexpected error occurred";
    }

    dispatch(authActions.requestFail(errorMessage));
    return { success: false, error: errorMessage };
  }
};

export const validateAuthState = function () {
  const state = store.getState();
  const { auth } = state;

  // Check if authentication is incomplete or invalid
  const isInvalidAuth =
    !auth.isAuthenticated ||
    !auth.accessToken ||
    !auth.user ||
    !auth.user.userId ||
    !auth.user.username ||
    auth.user.userTypeInfo === undefined ||
    auth.user.userTypeInfo === null;

  if (isInvalidAuth) {
    logout();
    return false;
  }

  return true;
};

export const checkAuth = function () {
  const state = store.getState();
  const accessToken = state.auth.accessToken;

  // First check if auth state is valid
  if (!validateAuthState()) {
    return false;
  }

  if (accessToken && !state.auth.accessToken) {
    return true;
  }

  return !!accessToken;
};

export const logout = function () {
  dispatch(authActions.logOut());
  try {
    localStorage.removeItem("persist:root");
    sessionStorage.removeItem("persist:root");
  } catch (err) {
    // Ignore storage cleanup errors
  }

  // Navigate to login page
  if (typeof window !== "undefined") {
    window.location.href = "/login";
  }
};

export const getAccessToken = function () {
  return store.getState().auth.accessToken;
};

export const clearAuthError = function () {
  dispatch(authActions.clearError());
};
